<template>
    <div class="content-wrapper" v-if="loaded == true">
        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
              <div class="row breadcrumbs-top">
                <div class="col-12">
                  <h2 class="content-header-title float-left mb-0">{{letterData.title}}</h2>
                  <div class="breadcrumb-wrapper">
                    <ol class="breadcrumb" v-if="letterData.breadcrumbs">
                        <li class="breadcrumb-item" v-for="(breadcrumb,index) in letterData.breadcrumbs">
                            <a :href="breadcrumb.link">
                                {{breadcrumb.name}}
                            </a>
                        </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <section id="validation">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-content">
                            <div class="card-body">
                                <div v-if="$route.params.letter == letterStore.PERSONAL_INFORMATION_LETTER">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.INQUIRY_REMOVAL_LETTER_1">
                                    <inquiry-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.INQUIRY_REMOVAL_LETTER_2">
                                    <inquiry-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.INQUIRY_DISPUTE_LETTER_ROUND_3">
                                    <inquiry-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.OPT_OUT_PRE_SCREEN_ATTACK">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.REINSERTION_DISPUTE_LETTER">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.METHOD_TO_VERIFICATION_LETTER">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.STALL_LETTER_RESPONSE">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.FAILURE_TO_RESPOND_WITHIN_15_DAYS">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.FAILURE_TO_RESPOND_WITHIN_30_DAYS">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.FAILED_TO_MARK_NOTICE_OF_DISPUTE">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.REQUEST_TO_REMOVE_FRAUD_ALERT">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.METHOD_TO_VERIFICATION_LETTER">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_COLLECTION_CHARGE_OFF_VERIFICATION_LETTER_1">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_COLLECTION_CHARGE_OFF_VERIFICATION_LETTER_2">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_COLLECTION_CHARGE_OFF_VERIFICATION_LETTER_3">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_COLLECTION_CHARGE_OFF_VERIFICATION_LETTER_4">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_CHARGE_OFF_LETTER_1">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_CHARGE_OFF_LETTER_2">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_CHARGE_OFF_LETTER_3">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_STUDENT_LOAN_LETTER_1">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_REPOSSESSION_LETTER_1">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_REPOSSESSION_LETTER_3">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAUS_STUDENT_LOAN_LETTER_4">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAU_LATE_PAYMENT_LETTER_1">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAU_LATE_PAYMENT_LETTER_2">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAU_LATE_PAYMENT_LETTER_3">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDIT_BUREAU_LATE_PAYMENT_LETTER_4">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.INQUIRY_REMOVAL_LETTER_3">
                                    <creditor-inquiry-letter />
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.INQUIRY_REMOVAL_LETTER_4">
                                    <creditor-inquiry-letter/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.LEXISNEXIS_CREDIT_FREEZE_REQUEST">
                                    <lexisnexis-credit-freeze-request :credit-bureaus='letterData.creditBureaus'/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.COURT_INFORMATION_RELEASE_POLICY">
                                    <courthouse-letter :credit-bureaus='letterData.creditBureaus'></courthouse-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.BANKRUPTCY_DISPUTE_LETTER_1">
                                    <public-record-letter :prop-credit-bureaus='letterData.creditBureaus'></public-record-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.BANKRUPTCY_DISPUTE_LETTER_2">
                                    <public-record-letter :prop-credit-bureaus='letterData.creditBureaus'></public-record-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDITOR_ATTORNEY_GENERAL_LETTER_1">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.COLLECTION_DISPUTE_LETTER_1_A">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDITOR_COLLECTION_CHARGE_OFF_VALIDATION_LETTER_2">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDITOR_COLLECTION_CHARGE_OFF_VALIDATION_LETTER_3">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDITOR_CHARGE_OFF_LETTER_1">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CHILD_SUPPORT_LETTER_1">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CHILD_SUPPORT_LETTER_2">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.STUDENT_LOAN_LETTER_2">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.STUDENT_LOAN_LETTER_3">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDITOR_LATE_PAYMENT_1">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDITOR_LATE_PAYMENT_2">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_1">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_2">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_3">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CREDITOR_REPOSSESSION_LETTER_4">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.SECURITY_FREEZE_ATTACK">
                                    <data-furnisher-letter/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.REQUEST_FOR_DISCLOSURE_ATTACK">
                                    <data-furnisher-letter/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.REQUEST_AN_INVESTIGATION_ATTACK">
                                    <data-furnisher-letter/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.REQUEST_FOR_VERIFICATION_ROUND_1">
                                    <request-for-verification-round-1 :credit-bureaus='letterData.creditBureaus'/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.REQUEST_FOR_VERIFICATION_ROUND_2">
                                    <request-for-verification-round-2 :credit-bureaus='letterData.creditBureaus'/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.REQUEST_FOR_VERIFICATION_ROUND_3">
                                    <request-for-verification-round-3 :credit-bureaus='letterData.creditBureaus'/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.DEMAND_FOR_REMOVAL_LETTER">
                                    <demand-for-removal-letter :credit-bureaus='letterData.creditBureaus'/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.CEASE_DESIST_LETTER">
                                    <cease-desist-letter :prop-credit-bureaus='letterData.creditBureaus'/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.AFFIDAVIT_OF_TRUTH_LETTER">
                                    <affidavit-of-truth-letter :prop-credit-bureaus='letterData.creditBureaus'/>
                                </div>

                                <div v-else-if="$route.params.letter == letterStore.DEBT_VALIDATION_LETTER">
                                    <debt-validation-letter :prop-credit-bureaus='letterData.creditBureaus'/>
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.REQUESTING_THE_REMOVAL_OF_INACCURATE_INFORMATION">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.REQUESTING_THE_REMOVAL_OF_INACCURATE_ACCOUNTS_ROUND2">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.REQUESTING_THE_REMOVAL_OF_INACCURATE_ACCOUNTS_ROUND3">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.INTENT_TO_FILE_SUIT_VIOLATION_OF_THE_FCRA">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.COLLECTION_DISPUTE_LETTER_1_B">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.COLLECTION_DISPUTE_LETTER_2">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.COLLECTION_DISPUTE_LETTER_3">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.COLLECTION_DISPUTE_LETTER_4">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.LATE_PAYMENT_DISPUTE_LETTER_1">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.LATE_PAYMENT_DISPUTE_LETTER_2">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.LATE_PAYMENT_DISPUTE_LETTER_3">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.LATE_PAYMENT_DISPUTE_LETTER_4">
                                    <bureau-letter :prop-credit-bureaus='letterData.creditBureaus' />
                                </div>
                                <div v-else-if="$route.params.letter == letterStore.REPOSSESSION_LETTER_1">
                                    <creditor-letter :prop-credit-bureaus='letterData.creditBureaus'></creditor-letter>
                                </div>

                                <!-- upload client credit report -->
                                <div v-else-if="
                                    (userStore.user?.owner?.id == letterData.letter?.user_id && (userStore.user?.isClient || userStore.user?.isBusinessUser))
                                    ||
                                    (userStore.user?.id == letterData.letter?.user_id && userStore.user?.isDIY)
                                ">
                                    <custom-letter
                                        :letter='letterData.letter'
                                        :credit-bureaus='letterData.creditBureaus'
                                    >
                                    </custom-letter>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

</template>
<script>
    import { useLetterStore } from '../../../stores/LetterStore.js'
    import { useLocalizationStore } from '../../../stores/LocalizationStore.js';
    import { useUserStore } from '../../../stores/UserStore.js'
    import {ref,reactive} from 'vue'

export default {
    name : 'DisputeLetterViewComponent',
    components:{
    },
    setup(){
        return{
            letterStore:useLetterStore(),
            letterData:reactive({}),
            loaded:ref(false),
            userStore:useUserStore(),
            localizationStore: useLocalizationStore(),
            _: _,
        }
    },
    mounted() {
        this.fetchLetter();
    },
    methods: {
        fetchLetter(){
            const route = this.$router.resolve({
                name: 'dispute-letter',
                params: {
                    client: this.$route.params.client,
                    letter: this.$route.params.letter,
                    team: this.$route.params.team,
                }
            }),
            $this = this;
            axios.post(route.href)
            .then(function (response) {
                if(response.data.error != true) {
                    $this.loaded = true;
                    Object.assign($this.letterData, response.data.data);
                    return;
                }
                toastr.error(response.data.message, 'Error!');
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    },
}
</script>
